function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.4
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.0001 5C6.0001 2.79086 7.79096 1 10.0001 1C12.2092 1 14.0001 2.79086 14.0001 5H18C18.5523 5 19 5.44772 19 6C19 6.55228 18.5523 7 18 7H16.7607L15.4444 18H4.55556L3.23932 7H2C1.44772 7 1 6.55228 1 6C1 5.44772 1.44772 5 2 5H6.0001ZM10.0001 3C11.1047 3 12.0001 3.89543 12.0001 5H8.0001C8.0001 3.89543 8.89553 3 10.0001 3ZM14.7464 7L13.6695 16H6.33051L5.25358 7H14.7464Z"
}));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.9b7469e0.svg";
export { ForwardRef as ReactComponent };